export default __webpack_public_path__ + "static/media/CLA.b4d4f6a3.png";